// ============================================
// MAISON MOSSEN - SYSTÈME DE RECHERCHE PERSONNALISÉ
// (Header masqué + barre de recherche pleine largeur + voile sombre)
// ============================================

// Recherches tendances affichées à l'ouverture (sans saisie)
var MOSSEN_TRENDS = [
  { label: 'Tops',       url: '/collections/tops' },
  { label: 'Shorts',     url: '/collections/jupes-shorts' },
  { label: 'Pantalons',  url: '/collections/pantalons' },
  { label: 'Sandales',   url: '/search?q=sandales' },
  { label: 'Bracelets',  url: '/collections/mossen-s-jewels' }
];

// Injection des styles
(function injectSearchStyles() {
  const styleId = 'mossen-search-styles';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.innerHTML = `
    /* Header masqué pendant la recherche */
    #mossen-header-persistent {
      transition: opacity 0.2s ease, visibility 0.2s ease;
    }
    body.mossen-search-open #mossen-header-persistent {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }

    /* Conteneur plein écran = voile sombre */
    #mossenSearchOverlay {
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0, 0, 0, 0.35);
      opacity: 0;
      transition: opacity 0.25s ease;
      z-index: 1000004;
    }
    #mossenSearchOverlay.open { opacity: 1; }

    /* Barre de recherche pleine largeur, à la place du header */
    #mossenSearchBar {
      display: flex;
      align-items: center;
      gap: 14px;
      height: 60px;
      padding: env(safe-area-inset-top) 20px 0;
      box-sizing: content-box;
      background: #fff;
      border-bottom: 1px solid #ededed;
    }
    #mossenSearchBar svg { flex-shrink: 0; }
    #mossenSearchClose {
      flex-shrink: 0;
      width: 32px; height: 32px;
      margin-right: -8px;
      padding: 0;
      border: none;
      background: none;
      cursor: pointer;
      position: relative;
    }
    #mossenSearchClose::before,
    #mossenSearchClose::after {
      content: '';
      position: absolute;
      top: 50%; left: 50%;
      width: 16px; height: 1px;
      background: #111;
    }
    #mossenSearchClose::before { transform: translate(-50%, -50%) rotate(45deg); }
    #mossenSearchClose::after  { transform: translate(-50%, -50%) rotate(-45deg); }

    /* Panneau blanc compact (hauteur = contenu) */
    #mossenSearchPanel {
      background: #fff;
      max-height: 65vh;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      box-shadow: 0 14px 30px rgba(0,0,0,0.12);
      border-bottom: 1px solid rgba(0,0,0,0.06);
    }

    .mossen-kw-row {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 13px 20px;
      text-decoration: none;
      color: #111;
      font-family: var(--font-heading-family, Arial, sans-serif);
      font-size: 14px;
    }
    .mossen-kw-row:hover { background: #f7f7f7; }
    .mossen-kw-row svg { flex-shrink: 0; }
    .mossen-kw-row b { font-weight: 700; }
    .mossen-kw-thumb {
      width: 40px;
      height: 52px;
      object-fit: cover;
      object-position: top;
      flex-shrink: 0;
      margin-left: 12px;
    }
    .mossen-kw-title {
      font-family: var(--font-heading-family, Arial, sans-serif);
      font-size: 10px;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      color: #111;
      margin: 0 0 14px;
    }
    .mossen-kw-chip {
      display: inline-block;
      padding: 8px 16px;
      background: #f4f4f4;
      border-radius: 3px;
      font-family: var(--font-heading-family, Arial, sans-serif);
      font-size: 12px;
      color: #111;
      text-decoration: none;
      transition: background 0.2s ease;
    }
    .mossen-kw-chip:hover { background: #eaeaea; }
    .mossen-kw-msg {
      font-family: var(--font-heading-family, Arial, sans-serif);
      font-size: 12px;
      color: #bbb;
      padding: 16px 20px;
    }
    .mossen-live-input {
      flex: 1;
      min-width: 0;
      border: none !important;
      outline: none !important;
      background: transparent !important;
      background-color: transparent !important;
      box-shadow: none !important;
      font-family: var(--font-heading-family, Arial, sans-serif);
      font-size: 16px;
      color: #111;
      letter-spacing: 0.02em;
      padding: 0 !important;
    }
    .mossen-live-input::placeholder { color: #888; }
  `;
  document.head.appendChild(style);
})();

// ============================================
// OUVRIR LA RECHERCHE (header masqué, barre pleine largeur)
// ============================================
window.triggerHeader = function() {
  if (document.getElementById('mossenSearchOverlay')) return;

  // 1) Voile sombre + barre de recherche + panneau blanc (un seul élément)
  const overlay = document.createElement('div');
  overlay.id = 'mossenSearchOverlay';
  overlay.innerHTML = `
    <div id="mossenSearchBar">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round">
        <circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/>
      </svg>
      <input type="text" class="mossen-live-input" placeholder="Rechercher" autocomplete="off" enterkeyhint="search">
      <button type="button" id="mossenSearchClose" aria-label="Fermer la recherche"></button>
    </div>
    <div id="mossenSearchPanel">
      <div id="mossenTextSuggest" style="display:flex;flex-direction:column;padding:6px 0;"></div>
    </div>`;
  document.body.appendChild(overlay);

  // 2) Masque le header et bloque le défilement de la page
  document.body.classList.add('mossen-search-open');
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function() { overlay.classList.add('open'); });

  const input = overlay.querySelector('.mossen-live-input');
  setTimeout(function() { input.focus(); }, 60);

  // Croix ou clic sur le voile sombre (hors barre et panneau) = fermeture
  overlay.querySelector('#mossenSearchClose').addEventListener('click', mossenCloseSearch);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) mossenCloseSearch();
  });

  // 3) État initial : recherches tendances
  mossenShowTrending();

  // 4) Recherche en direct
  let timer;
  input.addEventListener('input', function() {
    clearTimeout(timer);
    const q = this.value.trim();
    timer = setTimeout(function() {
      if (q) mossenLiveSearch(q);
      else mossenShowTrending();
    }, 200);
  });
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      const q = this.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
    }
    if (e.key === 'Escape') mossenCloseSearch();
  });
};

// ============================================
// FERMETURE
// ============================================
window.mossenCloseSearch = function() {
  const overlay = document.getElementById('mossenSearchOverlay');
  if (overlay) overlay.remove();
  document.body.style.overflow = '';
  document.body.classList.remove('mossen-search-open');
};

// ============================================
// ÉTAT PAR DÉFAUT : RECHERCHES TENDANCES
// ============================================
function mossenShowTrending() {
  const suggest = document.getElementById('mossenTextSuggest');
  if (!suggest) return;
  suggest.innerHTML = `
    <div style="padding:18px 20px;">
      <p class="mossen-kw-title">Recherches tendances</p>
      <div style="display:flex;flex-wrap:wrap;gap:8px;">
        ${MOSSEN_TRENDS.map(function(t) {
          return `<a href="${t.url}" class="mossen-kw-chip">${t.label}</a>`;
        }).join('')}
      </div>
    </div>`;
}

// ============================================
// RÉSULTATS PERTINENTS
// ============================================
async function mossenLiveSearch(query) {
  const suggest = document.getElementById('mossenTextSuggest');
  if (!suggest) return;
  if (!query) { mossenShowTrending(); return; }

  suggest.innerHTML = `<p class="mossen-kw-msg">Recherche…</p>`;

  try {
    const res = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}` +
      `&resources[type]=query,product&resources[limit]=10`
    );
    const data = await res.json();
    const results = data.resources?.results || {};

    let items = (results.queries || []).map(function(q) {
      return { html: q.styled_text || q.text, url: q.url || ('/search?q=' + encodeURIComponent(q.text)), image: null };
    });
    if (items.length === 0) {
      items = (results.products || []).map(function(p) {
        return {
          html: p.title,
          url: p.url || ('/search?q=' + encodeURIComponent(p.title)),
          image: p.featured_image?.url || p.image || null
        };
      });
    }

    if (items.length === 0) {
      suggest.innerHTML = `<p class="mossen-kw-msg">Aucune suggestion pour « ${query} »</p>`;
      return;
    }

    suggest.innerHTML = items.map(function(it) {
      return `
        <a href="${it.url}" class="mossen-kw-row">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="1.5" stroke-linecap="round">
            <circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/>
          </svg>
          <span style="flex:1;">${it.html}</span>
          ${it.image ? `<img src="${it.image}" class="mossen-kw-thumb" alt="">` : ''}
        </a>`;
    }).join('');
  } catch (err) {
    suggest.innerHTML = `<p class="mossen-kw-msg" style="color:#e63946;">Erreur de recherche.</p>`;
  }
}

// Export global
window.mossenSearchModule = {
  open: window.triggerHeader,
  close: window.mossenCloseSearch,
  search: mossenLiveSearch
};